import './pagination.scss';

import Button, { ButtonState, ButtonType } from '../button/Button';

import { IconType } from '../icon/Icon';

interface PaginationProps {
  currentPage?: number;
  total?: number;
  handleGoToFirst?: () => void;
  handleGoToPrevious?: () => void;
  handleGoToNext?: () => void;
  handleGoToLast?: () => void;
  systemSelectorLabels?: any;
  loading?: boolean;
}

const Pagination = ({
  currentPage = 1,
  total = 1,
  handleGoToFirst,
  handleGoToPrevious,
  handleGoToNext,
  handleGoToLast,
  systemSelectorLabels = {
    itemsPerPage: 'Items per page|items',
  },
  loading = false,
}: PaginationProps) => {
  // TODO: Add loading state handling
  return (
    <div className="pagination">
      <div className="pagination__info u-label-small">
        <span className="pagination__current">{`${
          systemSelectorLabels?.itemsPerPage?.split('|')[0]
        } ${currentPage}`}</span>
        {` ${systemSelectorLabels?.itemsPerPage?.split('|')[1]} ${total}`}
      </div>
      <div className="pagination__paging">
        <Button
          type={ButtonType.SECONDARY}
          state={
            currentPage === 1 || loading
              ? ButtonState.DISABLED
              : ButtonState.DEFAULT
          }
          icon={IconType.DoubleArrowLeft}
          description="Go to first page"
          onClick={handleGoToFirst}
        />
        <Button
          type={ButtonType.SECONDARY}
          state={
            currentPage === 1 || loading
              ? ButtonState.DISABLED
              : ButtonState.DEFAULT
          }
          icon={IconType.ArrowLeft}
          description="Go to previous page"
          onClick={handleGoToPrevious}
        />
        <Button
          type={ButtonType.SECONDARY}
          state={
            currentPage === total || loading
              ? ButtonState.DISABLED
              : ButtonState.DEFAULT
          }
          icon={IconType.ArrowRight}
          description="Go to next page"
          onClick={handleGoToNext}
        />
        <Button
          type={ButtonType.SECONDARY}
          state={
            currentPage === total || loading
              ? ButtonState.DISABLED
              : ButtonState.DEFAULT
          }
          icon={IconType.DoubleArrowRight}
          description="Go to last page"
          onClick={handleGoToLast}
        />
      </div>
    </div>
  );
};

export default Pagination;
